import { render, staticRenderFns } from "./EmargementPage.vue?vue&type=template&id=130105cb&"
import script from "./EmargementPage.vue?vue&type=script&lang=js&"
export * from "./EmargementPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports